import { render, staticRenderFns } from "./ExpectFromUs.vue?vue&type=template&id=02b34b9a&scoped=true&"
import script from "./ExpectFromUs.vue?vue&type=script&lang=ts&"
export * from "./ExpectFromUs.vue?vue&type=script&lang=ts&"
import style0 from "./ExpectFromUs.vue?vue&type=style&index=0&id=02b34b9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b34b9a",
  null
  
)

export default component.exports